<template>
  <div class="overlapping-headline">
    <div class="headline--top" :class="topColor">{{topText}}</div>
    <div class="headline--bottom" :class="bottomColor">{{bottomText}}</div>
  </div>
</template>

<script>

export default {
  name: 'stacked-headline',
  props: {
    topText: String,
    topColor: String,
    bottomText: String,
    bottomColor: String
  }
}
</script>

<style scoped lang="scss">
/** navigation **/
@import '../theme';

.overlapping-headline {
  display: inline-block;
  position: relative;
  transform: scale(.75);
  
  @include media-breakpoint-up(md) {
    transform: scale(1);
  }
  
  .headline--top {
    position: absolute;
    width: 100%;
    top: 50%;
    left: -5%;
    transform: translateY(-50%);
    @include zespri-small-callout;
    font-size: 5vw;
    
    @include media-breakpoint-up(md) {
      font-size: 2.5vw;
    }
    
    @include media-breakpoint-up(xl) {
      font-size: $f-l;
    }
    
    &.dark-green {
      color: zespri-brand-color(dark-green);
    }
  }
  
  .headline--bottom {
    @include zespri-large-callout;
    font-size: 15vw;
    color: white;
    
    @include media-breakpoint-up(md) {
      font-size: 9.5vw;
    }
    
    @include media-breakpoint-up(xl) {
      font-size: $f-xxl;
    }
    
    &.white {
      color: zespri-brand-color(white);
    }
    
    &.yellow {
      color: zespri-brand-color(yellow);
    }
    
    &.green {
      color: zespri-brand-color(green);
    }
    
    &.dark-green {
      color: zespri-brand-color(dark-green);
    }
  }
}

</style>
